module.exports = __webpack_public_path__ + "assets/img/Call.1afa67a3.png";